/**
 * Utility functions for Swiper configuration
 */

/**
 * Determines if loop mode should be enabled based on the number of slides
 * @param slidesCount - Number of slides
 * @param slidesPerView - Number of slides per view (default: 1)
 * @param slidesPerGroup - Number of slides per group (default: 1)
 * @returns boolean - Whether loop should be enabled
 */
export const shouldEnableLoop = (
  slidesCount: number, 
  slidesPerView: number = 1, 
  slidesPerGroup: number = 1
): boolean => {
  // Loop needs at least (slidesPerView + slidesPerGroup) slides to work properly
  const minSlidesNeeded = slidesPerView + slidesPerGroup;
  return slidesCount >= minSlidesNeeded;
};

/**
 * Gets safe Swiper loop configuration
 * @param slidesCount - Number of slides
 * @param slidesPerView - Number of slides per view (default: 1)
 * @param slidesPerGroup - Number of slides per group (default: 1)
 * @returns object - Safe loop configuration
 */
export const getSafeLoopConfig = (
  slidesCount: number,
  slidesPerView: number = 1,
  slidesPerGroup: number = 1
) => {
  return {
    loop: shouldEnableLoop(slidesCount, slidesPerView, slidesPerGroup),
    slidesPerView,
    slidesPerGroup
  };
}; 